import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IMenu } from '@appNeo/core/interfaces/IMenu';
import { BYPASS_SIN_TOKEN } from '@appNeo/neoCore/interceptors/jwt/jwt.interceptor';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';

import { environment } from '@environments/environment';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, Subject, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainHeaderService {

  urlEntidad = environment.api_base_url_backoffice + '/menufront';

  contextoSinToken = { context: new HttpContext().set(BYPASS_SIN_TOKEN, true) };
  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();
  public menuHeader$: BehaviorSubject<any> = new BehaviorSubject<any>(null);  

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    
  ) { 
    
  }
  
  set menuHeader(menuHeader: any) {
    if ( menuHeader ) {
      // this.entidadesRelacionadas( menu ).subscribe( response => {
        let menuHeaderMapeada = { ...menuHeader};
        this.menuHeader$.next(menuHeaderMapeada);
      // })
    }
    
  }

  getAll(tipoPaginador?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<any> {
    // TODO establecer idioma defecto del store
    let idIdiomaDefecto = 1;
    let _filtros = (!filtros?.idIdioma || (filtros?.idIdioma && filtros.idIdioma.length <=0) ) ? {...filtros, 'idIdioma': idIdiomaDefecto} : filtros
    let request = (tipoPaginador === TipoPaginadorEnum.offline) 
    ? this.urlEntidad 
    : `${this.urlEntidad}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(_filtros)}`;
    return this.http.get(request, { ...this.contextoSinToken }).pipe(
        tap( (data: IRespApi )=> this.menuHeader$.next( this.mapearEntidad(data.data) )),
      map((data: IRespApi) => this.mapearEntidad(data.data)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestMenuFront');
      })
    ); 
  }

  // mapearEntidad( entidad: any ):any{
  //    // let fechaFormatt = new Date(item?.fecha);
  //   // let fechaFormatt = this.datepipe.transform(item?.fecha, 'dd/MM/yyyy');
  //   // let importeFormatt = item.importe.toFixed(2);
  //   let item = Object.assign({}, entidad);
  //   Object.entries(item).filter(([identificadorItemMenu, contenidoItemMenu]) => {
  //     item[identificadorItemMenu].id = identificadorItemMenu;
  //     console.log(`Opcion ${identificadorItemMenu} es el menu `, contenidoItemMenu);
  //   });
  //   let camposTraduccion = {};
  //   // if(item?.idiomas) {
  //   //   camposTraduccion = this.auxiliar.obtenerContenidoPorIdioma(item.idiomas);
  //   // }
  //   let _item = {...item, ...camposTraduccion};
  //   return _item;
  // }

  mapearEntidad( entidad: any ):any{
    // let fechaFormatt = new Date(item?.fecha);
   // let fechaFormatt = this.datepipe.transform(item?.fecha, 'dd/MM/yyyy');
   // let importeFormatt = item.importe.toFixed(2);
   let item = Object.assign({}, entidad);
   let menuMapeado = [];
   Object.entries(item).filter(([identificadorItemMenu, contenidoItemMenu]) => {
     contenidoItemMenu['id'] = identificadorItemMenu;
     menuMapeado.push(contenidoItemMenu);
   });
   return menuMapeado;
 }


 
  /************************************ 
  * Funciones apoyo                  *
  *************************************/
   resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
     return this.getAll().pipe(
       catchError(err => of('sin menufront'))
     )
  }

  private handleError(err: IRespApi, idRequest = '') {
    
    // dialog específico
    if ( err.codigoError === 422) {
      err.request = idRequest;
      this.error422Api$.next(err);
    } 

    // pantalla común
    let mensaje = err?.mensaje;
    if ( err.codigoError === 403) {
      mensaje = `${ err.mensaje }: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if ( err.data ) {
        if ( typeof err.data === 'string') {
          avisos = err.data;
        }else {
          err.data.forEach(element => {
            if ( element.id === 999 ) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje +  avisos;
    }
    return throwError({'error' : true, 'data': err.data, mensaje });
  }
}
